<script>
  import { DatePicker } from 'element-ui'
  import { getDate } from '@/utils/index'
 DatePicker.mixins.push({
   props: {
     yearFirst: {
       type: Boolean,
       default: false
     }
   },
  watch: {
    pickerVisible(value) {
      if (value && this.yearFirst) {
        this.picker.currentView = 'year'
        this.picker.defaultValue = '1990-01-01'
      }
    }
  }
})
  export default {
    name: 'DateLimit',
    functional: true,
    render(createElement, { props, data, children }) {
      let { noLimit = false, limitTime = new Date(new Date(window.formateTimesStamp()).setHours(0, 0, 0, 0)), limitAfterNow = false, includeNow = false, minTime = '', yearFirst = false } = props
      Object.assign(data, {
        props: Object.assign(props, {
          yearFirst,
          valueFormat: 'yyyy-MM-dd',
          editable: false,
          clearable: props.hasOwnProperty('clearable') ? props.clearable : true,
          pickerOptions: {
            disabledDate(time) {
              if (noLimit) { // 如果不做限制的话
                return false
              }
              if (limitAfterNow) {
                if (includeNow) {
                  return time.getTime() < new Date(limitTime).getTime()
                }
                return time.getTime() <= new Date(limitTime).getTime()
              }
              if (includeNow) {
                if (minTime) {
                  return time.getTime() > new Date(limitTime).getTime() ||  time.getTime() < new Date(getDate(-1, new Date(minTime))).getTime()
                }
                return time.getTime() > new Date(limitTime).getTime()
              }
              return time.getTime() >= new Date(limitTime).getTime()
            }
          }
        })
      })
      return createElement(
        DatePicker,
        data,
        children
      )
    }
  }
</script>
